import { generateAppUpdateTemplate } from "../utils/templateGenerator";
import { EMAIL_ASSETS } from "../config/emailAssets";

export interface PreBuiltTemplate {
  id: string;
  name: string;
  subject: string;
  content: string;
  description: string;
  category: string;
  isHtml: boolean;
}

export const preBuiltTemplates: PreBuiltTemplate[] = [
  {
    id: "app-update-notification",
    name: "App Update Required - FreeSpeek 1.1.8",
    subject:
      "Update Your FreeSpeek App - New Features & Improvements Available!",
    description:
      "Professional template to notify users to update to the latest app version",
    category: "App Updates",
    isHtml: true,
    content: generateAppUpdateTemplate(),
  },
  {
    id: "welcome-new-user",
    name: "Welcome to FreeSpeek",
    subject: "Welcome to FreeSpeek - Let's Get Started!",
    description: "Professional welcome email for new users joining FreeSpeek",
    category: "Welcome",
    isHtml: true,
    content: `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Welcome to FreeSpeek</title>
    <style>
        body {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;
            line-height: 1.6;
            color: #333;
            margin: 0;
            padding: 0;
            background-color: #000;
        }
        .container {
            max-width: 600px;
            margin: 0 auto;
            background-color: #ffffff;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
        }
        .header {
            background: linear-gradient(135deg, #000 0%, #02FEFE 100%);
            color: white;
            padding: 40px 20px;
            text-align: center;
            position: relative;
        }
        .logo {
            width: 80px;
            height: 80px;
            margin: 0 auto 20px;
            background: url('${EMAIL_ASSETS.LOGO}') no-repeat center;
            background-size: contain;
            border-radius: 20px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }
        .header h1 {
            margin: 0;
            font-size: 32px;
            font-weight: bold;
            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        }
        .header p {
            margin: 10px 0 0;
            font-size: 16px;
            opacity: 0.9;
        }
        .content {
            padding: 40px 30px;
        }
        .greeting {
            font-size: 18px;
            color: #333;
            margin-bottom: 20px;
        }
        .main-text {
            font-size: 16px;
            color: #555;
            margin-bottom: 25px;
        }
        .welcome-box {
            background: linear-gradient(135deg, #02FEFE 0%, #00E6E6 100%);
            color: #000;
            padding: 25px;
            border-radius: 12px;
            margin: 25px 0;
            text-align: center;
            font-weight: 600;
        }
        .features-section {
            background-color: #f8f9fa;
            border-left: 4px solid #02FEFE;
            padding: 25px;
            margin: 25px 0;
            border-radius: 0 12px 12px 0;
        }
        .features-section h3 {
            color: #333;
            margin-top: 0;
            font-size: 20px;
            font-weight: bold;
        }
        .feature-list {
            list-style: none;
            padding: 0;
        }
        .feature-list li {
            padding: 8px 0;
            position: relative;
            padding-left: 25px;
        }
        .feature-list li:before {
            content: "✓";
            position: absolute;
            left: 0;
            color: #02FEFE;
            font-weight: bold;
            font-size: 16px;
        }
        .get-started-section {
            text-align: center;
            margin: 40px 0;
            padding: 30px 0;
            background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
            border-radius: 12px;
        }
        .cta-button {
            display: inline-block;
            padding: 0;
            text-decoration: none;
            border-radius: 8px;
            transition: transform 0.2s ease;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
            flex: 0 0 auto;
        }
        .cta-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }
        .store-button {
            height: 60px;
            width: 180px;
            border-radius: 8px;
            display: block;
            object-fit: contain;
        }
        .cta-buttons {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 40px;
            margin: 30px 0;
            flex-wrap: nowrap;
        }
        .footer {
            background: linear-gradient(135deg, #000 0%, #02FEFE 100%);
            color: #fff;
            padding: 30px 20px;
            text-align: center;
        }
        .footer p {
            margin: 5px 0;
            font-size: 14px;
        }
        .footer .team-signature {
            color: #02FEFE;
            font-weight: bold;
        }
        .social-links {
            margin: 20px 0;
        }
        .social-links a {
            color: #02FEFE;
            text-decoration: none;
            margin: 0 10px;
            font-weight: bold;
        }
        @media (max-width: 600px) {
            .container {
                margin: 0;
                border-radius: 0;
            }
            .content {
                padding: 30px 20px;
            }
            .logo {
                width: 70px;
                height: 70px;
            }
            .cta-buttons {
                flex-direction: column;
                align-items: center;
                gap: 25px;
                padding: 0 20px;
            }
            .cta-button {
                margin: 10px 0;
                width: 100%;
                max-width: 250px;
                text-align: center;
            }
            .store-button {
                width: 100%;
                max-width: 250px;
                height: auto;
                min-height: 50px;
            }
            /* Mobile responsive table layout */
            .get-started-section table {
                width: 100% !important;
            }
            .get-started-section table tr {
                display: block !important;
                width: 100% !important;
            }
            .get-started-section table td {
                display: block !important;
                width: 100% !important;
                padding: 15px 0 !important;
                text-align: center !important;
            }
            .get-started-section table td img {
                width: 100% !important;
                max-width: 250px !important;
                height: auto !important;
                min-height: 50px !important;
            }
        }
    </style>
</head>
<body>
    <div class="container">
        <div class="header">
            <div class="logo"></div>
            <h1>Welcome to FreeSpeek!</h1>
            <p>Your journey to better communication starts here</p>
        </div>
        <div class="content">
            <div class="greeting">Hello {{userName}},</div>
            <div class="main-text">
                Welcome to the <strong>FreeSpeek community</strong>! We're absolutely thrilled to have you join our growing family of users who believe in the power of authentic, meaningful communication.
            </div>
            <div class="welcome-box">
                🎉 <strong>Congratulations!</strong> You've just taken the first step towards a more connected and engaging social experience.
            </div>
            <div class="features-section">
                <h3>🚀 What You Can Do on FreeSpeek:</h3>
                <ul class="feature-list">
                    <li><strong>Home Feed:</strong> Stay updated with posts from your community and connections</li>
                    <li><strong>Explore:</strong> Discover new content, people, and communities around you</li>
                    <li><strong>Create Posts:</strong> Share your thoughts, photos, and experiences with the community</li>
                    <li><strong>Buy & Sell:</strong> Browse and post items in our local marketplace</li>
                    <li><strong>Events:</strong> Create and join local events happening in your area</li>
                    <li><strong>Groups & Communities:</strong> Join neighborhood groups and create your own communities</li>
                    <li><strong>Polls:</strong> Create polls to get community opinions and feedback</li>
                    <li><strong>Safety Posts:</strong> Share urgent safety information and alerts</li>
                    <li><strong>Lost & Found:</strong> Report lost items or help others find their belongings</li>
                    <li><strong>Business Reviews:</strong> Rate and review local businesses and restaurants</li>
                    <li><strong>Messaging:</strong> Chat privately with other FreeSpeek users</li>
                    <li><strong>Local Services:</strong> Find and offer local services in your community</li>
                </ul>
            </div>
            <div class="get-started-section">
                <h3 style="margin-top: 0; margin-bottom: 20px; color: #333; font-size: 24px;">Ready to Get Started?</h3>
                <p style="color: #555; margin-bottom: 25px;">
                    Download the FreeSpeek app and start exploring all that we have to offer!
                </p>
                <!-- Email client compatible table layout -->
                <table width="100%" cellpadding="0" cellspacing="0" style="margin: 30px 0;">
                    <tr>
                        <td align="center" style="padding: 0 25px;">
                            <a href="https://apps.apple.com/pk/app/freespeek-app/id6741692095" class="cta-button" style="display: inline-block;">
                                <img src="${EMAIL_ASSETS.APP_STORE_BUTTON}" alt="Download on App Store" class="store-button" style="display: block; width: 180px; height: 60px; border-radius: 8px;">
                            </a>
                        </td>
                        <td align="center" style="padding: 0 25px;">
                            <a href="https://play.google.com/store/apps/details?id=com.freespeek_app" class="cta-button" style="display: inline-block;">
                                <img src="${EMAIL_ASSETS.GOOGLE_PLAY_BUTTON}" alt="Get it on Google Play" class="store-button" style="display: block; width: 180px; height: 60px; border-radius: 8px;">
                            </a>
                        </td>
                    </tr>
                </table>
                <!-- Fallback div layout for modern email clients -->
                <div class="cta-buttons" style="display: none;">
                    <a href="https://apps.apple.com/pk/app/freespeek-app/id6741692095" class="cta-button">
                        <img src="${EMAIL_ASSETS.APP_STORE_BUTTON}" alt="Download on App Store" class="store-button">
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.freespeek_app" class="cta-button">
                        <img src="${EMAIL_ASSETS.GOOGLE_PLAY_BUTTON}" alt="Get it on Google Play" class="store-button">
                    </a>
                </div>
            </div>
            <div style="text-align: center; margin: 30px 0; padding: 20px; background-color: #f8f9fa; border-radius: 8px;">
                <h4 style="color: #333; margin-top: 0;">💡 Pro Tips for New Users:</h4>
                <p style="color: #555; margin: 10px 0;">• Complete your profile with a photo to get more connections</p>
                <p style="color: #555; margin: 10px 0;">• Join neighborhood groups to connect with local community</p>
                <p style="color: #555; margin: 10px 0;">• Use the Explore tab to discover interesting content and people</p>
                <p style="color: #555; margin: 10px 0;">• Create your first post to introduce yourself to the community</p>
                <p style="color: #555; margin: 10px 0;">• Check out local events and marketplace for great opportunities</p>
            </div>
            <p style="text-align: center; font-size: 16px; color: #555; margin-top: 30px;">
                If you have any questions or need help getting started, don't hesitate to reach out to our support team.
            </p>
            <p style="text-align: center; font-size: 16px; color: #555;">
                Welcome aboard!<br><span class="team-signature">The FreeSpeek Team</span>
            </p>
        </div>
        <div class="footer">
            <p>© 2025 FreeSpeek. All rights reserved.</p>
            <p>Stay connected, stay safe, stay FreeSpeek!</p>
            <div class="social-links">
                <a href="mailto:support@freespeek.net">Support</a> |
                <a href="https://www.freespeek.net/privacy">Privacy Policy</a>
            </div>
        </div>
      </div>
</body>
</html>`,
  },
  {
    id: "password-reset",
    name: "Password Reset Request",
    subject: "Reset Your FreeSpeek Password",
    description: "Professional password reset email template",
    category: "Security",
    isHtml: true,
    content: `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Password Reset - FreeSpeek</title>
    <style>
        body {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;
            line-height: 1.6;
            color: #333;
            margin: 0;
            padding: 0;
            background-color: #000;
        }
        .container {
            max-width: 600px;
            margin: 0 auto;
            background-color: #ffffff;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
        }
        .header {
            background: linear-gradient(135deg, #000 0%, #02FEFE 100%);
            color: white;
            padding: 40px 20px;
            text-align: center;
            position: relative;
        }
        .logo {
            width: 80px;
            height: 80px;
            margin: 0 auto 20px;
            background: url('${EMAIL_ASSETS.LOGO}') no-repeat center;
            background-size: contain;
            border-radius: 20px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }
        .header h1 {
            margin: 0;
            font-size: 32px;
            font-weight: bold;
            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        }
        .header p {
            margin: 10px 0 0;
            font-size: 16px;
            opacity: 0.9;
        }
        .content {
            padding: 40px 30px;
        }
        .greeting {
            font-size: 18px;
            color: #333;
            margin-bottom: 20px;
        }
        .main-text {
            font-size: 16px;
            color: #555;
            margin-bottom: 25px;
        }
        .security-box {
            background: linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%);
            color: #fff;
            padding: 25px;
            border-radius: 12px;
            margin: 25px 0;
            text-align: center;
            font-weight: 600;
        }
        .cta-section {
            text-align: center;
            margin: 40px 0;
            padding: 30px 0;
            background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
            border-radius: 12px;
        }
        .cta-button {
            display: inline-block;
            background: linear-gradient(135deg, #02FEFE 0%, #00E6E6 100%);
            color: #000;
            padding: 15px 30px;
            text-decoration: none;
            border-radius: 8px;
            font-weight: bold;
            font-size: 16px;
            margin: 10px;
            transition: transform 0.2s ease;
            box-shadow: 0 4px 12px rgba(2, 254, 254, 0.3);
        }
        .cta-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(2, 254, 254, 0.4);
        }
        .footer {
            background: linear-gradient(135deg, #000 0%, #02FEFE 100%);
            color: #fff;
            padding: 30px 20px;
            text-align: center;
        }
        .footer p {
            margin: 5px 0;
            font-size: 14px;
        }
        .footer .team-signature {
            color: #02FEFE;
            font-weight: bold;
        }
        @media (max-width: 600px) {
            .container {
                margin: 0;
                border-radius: 0;
            }
            .content {
                padding: 30px 20px;
            }
            .logo {
                width: 70px;
                height: 70px;
            }
        }
    </style>
</head>
<body>
    <div class="container">
        <div class="header">
            <div class="logo"></div>
            <h1>Password Reset Request</h1>
            <p>Secure your FreeSpeek account</p>
        </div>
        <div class="content">
            <div class="greeting">Hello {{userName}},</div>
            <div class="main-text">
                We received a request to reset your FreeSpeek account password. If you made this request, click the button below to create a new password.
            </div>
            <div class="security-box">
                🔒 <strong>Security Notice:</strong> This link will expire in 24 hours for your security.
            </div>
            <div class="cta-section">
                <h3 style="margin-top: 0; margin-bottom: 20px; color: #333; font-size: 24px;">Reset Your Password</h3>
                <p style="color: #555; margin-bottom: 25px;">
                    Click the button below to securely reset your password.
                </p>
                <a href="{{resetLink}}" class="cta-button">Reset Password</a>
            </div>
            <div style="background-color: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0;">
                <h4 style="color: #333; margin-top: 0;">⚠️ Important Security Information:</h4>
                <p style="color: #555; margin: 10px 0;">• If you didn't request this reset, please ignore this email</p>
                <p style="color: #555; margin: 10px 0;">• Your password will not be changed until you click the link above</p>
                <p style="color: #555; margin: 10px 0;">• Never share your password with anyone</p>
            </div>
            <p style="text-align: center; font-size: 16px; color: #555; margin-top: 30px;">
                If you have any concerns about your account security, please contact our support team immediately.
            </p>
            <p style="text-align: center; font-size: 16px; color: #555;">
                Stay secure,<br><span class="team-signature">The FreeSpeek Team</span>
            </p>
        </div>
        <div class="footer">
            <p>© 2025 FreeSpeek. All rights reserved.</p>
            <p>Your security is our priority</p>
        </div>
      </div>
</body>
</html>`,
  },
  {
    id: "maintenance-notice",
    name: "Scheduled Maintenance",
    subject: "FreeSpeek Scheduled Maintenance Notice",
    description: "Professional maintenance notification email template",
    category: "System",
    isHtml: true,
    content: `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Scheduled Maintenance - FreeSpeek</title>
    <style>
        body {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;
            line-height: 1.6;
            color: #333;
            margin: 0;
            padding: 0;
            background-color: #000;
        }
        .container {
            max-width: 600px;
            margin: 0 auto;
            background-color: #ffffff;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
        }
        .header {
            background: linear-gradient(135deg, #000 0%, #02FEFE 100%);
            color: white;
            padding: 40px 20px;
            text-align: center;
            position: relative;
        }
        .logo {
            width: 80px;
            height: 80px;
            margin: 0 auto 20px;
            background: url('${EMAIL_ASSETS.LOGO}') no-repeat center;
            background-size: contain;
            border-radius: 20px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }
        .header h1 {
            margin: 0;
            font-size: 32px;
            font-weight: bold;
            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        }
        .header p {
            margin: 10px 0 0;
            font-size: 16px;
            opacity: 0.9;
        }
        .content {
            padding: 40px 30px;
        }
        .greeting {
            font-size: 18px;
            color: #333;
            margin-bottom: 20px;
        }
        .main-text {
            font-size: 16px;
            color: #555;
            margin-bottom: 25px;
        }
        .maintenance-box {
            background: linear-gradient(135deg, #ffa726 0%, #ffb74d 100%);
            color: #000;
            padding: 25px;
            border-radius: 12px;
            margin: 25px 0;
            text-align: center;
            font-weight: 600;
        }
        .time-section {
            background-color: #f8f9fa;
            border-left: 4px solid #ffa726;
            padding: 25px;
            margin: 25px 0;
            border-radius: 0 12px 12px 0;
        }
        .time-section h3 {
            color: #333;
            margin-top: 0;
            font-size: 20px;
            font-weight: bold;
        }
        .time-details {
            background-color: #fff;
            padding: 20px;
            border-radius: 8px;
            margin: 15px 0;
            border: 2px solid #ffa726;
        }
        .footer {
            background: linear-gradient(135deg, #000 0%, #02FEFE 100%);
            color: #fff;
            padding: 30px 20px;
            text-align: center;
        }
        .footer p {
            margin: 5px 0;
            font-size: 14px;
        }
        .footer .team-signature {
            color: #02FEFE;
            font-weight: bold;
        }
        @media (max-width: 600px) {
            .container {
                margin: 0;
                border-radius: 0;
            }
            .content {
                padding: 30px 20px;
            }
            .logo {
                width: 70px;
                height: 70px;
            }
        }
    </style>
</head>
<body>
    <div class="container">
        <div class="header">
            <div class="logo"></div>
            <h1>Scheduled Maintenance</h1>
            <p>We're improving FreeSpeek for you</p>
        </div>
        <div class="content">
            <div class="greeting">Hello {{userName}},</div>
            <div class="main-text">
                We wanted to give you advance notice that we'll be performing scheduled maintenance on our servers to improve performance and add new features.
            </div>
            <div class="maintenance-box">
                ⚠️ <strong>Maintenance Notice:</strong> FreeSpeek will be temporarily unavailable during the maintenance window.
            </div>
            <div class="time-section">
                <h3>🕐 Maintenance Schedule:</h3>
                <div class="time-details">
                    <p style="margin: 0; font-size: 18px; font-weight: bold; color: #333;">
                        📅 Date: {{maintenanceDate}}
                    </p>
                    <p style="margin: 10px 0 0; font-size: 16px; color: #555;">
                        ⏰ Time: {{startTime}} - {{endTime}} ({{timezone}})
                    </p>
                    <p style="margin: 10px 0 0; font-size: 14px; color: #666;">
                        Estimated Duration: {{duration}}
                    </p>
                </div>
            </div>
            <div style="background-color: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0;">
                <h4 style="color: #333; margin-top: 0;">📋 What to Expect:</h4>
                <p style="color: #555; margin: 10px 0;">• FreeSpeek app and website will be temporarily unavailable</p>
                <p style="color: #555; margin: 10px 0;">• All your data and messages are safe and secure</p>
                <p style="color: #555; margin: 10px 0;">• We'll notify you once maintenance is complete</p>
                <p style="color: #555; margin: 10px 0;">• New features and improvements will be available after maintenance</p>
            </div>
            <p style="text-align: center; font-size: 16px; color: #555; margin-top: 30px;">
                We apologize for any inconvenience and appreciate your patience as we work to make FreeSpeek even better for you.
            </p>
            <p style="text-align: center; font-size: 16px; color: #555;">
                Thank you for your understanding,<br><span class="team-signature">The FreeSpeek Team</span>
            </p>
        </div>
        <div class="footer">
            <p>© 2025 FreeSpeek. All rights reserved.</p>
            <p>Building a better FreeSpeek for you</p>
        </div>
      </div>
</body>
</html>`,
  },
];

export const getTemplateById = (id: string) => {
  return preBuiltTemplates.find((template) => template.id === id);
};

export const getAllCategories = () => {
  const categories = Array.from(
    new Set(preBuiltTemplates.map((template) => template.category))
  );
  return categories.sort();
};
